module.exports = __webpack_public_path__ + "static/media/ciencias-agrarias.36110b64.jpg";